<div
    *hasPermission="item.permissions"
    class="hippo-vertical-navigation-item-wrapper"
    [class.hippo-vertical-navigation-item-has-subtitle]="!!item.subtitle"
    [ngClass]="$safeNavigationMigration(item.classes?.wrapper)">
    <!-- Item with an internal link -->
    @if (item.link && !item.externalLink && !item.function && !item.disabled) {
        <div class="relative">
            <a
                class="hippo-vertical-navigation-item"
                [ngClass]="{
                    'hippo-vertical-navigation-item-active-forced': item.active,
                }"
                [routerLink]="[item.link]"
                [fragment]="item.fragment ?? null"
                [preserveFragment]="item.preserveFragment ?? false"
                [queryParams]="item.queryParams ?? null"
                [queryParamsHandling]="item.queryParamsHandling ?? null"
                [routerLinkActive]="'hippo-vertical-navigation-item-active'"
                [routerLinkActiveOptions]="isActiveMatchOptions"
                [matTooltip]="item.tooltip || ''">
                <ng-container *ngTemplateOutlet="itemTemplate"></ng-container>
            </a>
            @if (item.oldLink) {
                <a
                    class="z-10 absolute right-4 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-500 transition-colors duration-200"
                    [href]="item.oldLink"
                    [matTooltip]="item.tooltip || ''">
                    Alt
                </a>
            }
        </div>
    }

    <!-- Item with an external link -->
    @if (item.link && item.externalLink && !item.function && !item.disabled) {
        <a
            class="hippo-vertical-navigation-item"
            [href]="item.link"
            [target]="item.target || '_self'"
            [matTooltip]="item.tooltip || ''">
            <ng-container *ngTemplateOutlet="itemTemplate"></ng-container>
        </a>
    }

    <!-- Item with a function -->
    @if (!item.link && item.function && !item.disabled) {
        <div
            class="hippo-vertical-navigation-item"
            [ngClass]="{
                'hippo-vertical-navigation-item-active-forced': item.active,
            }"
            [matTooltip]="item.tooltip || ''"
            (click)="item.function(item)">
            <ng-container *ngTemplateOutlet="itemTemplate"></ng-container>
        </div>
    }

    <!-- Item with an internal link and function -->
    @if (item.link && !item.externalLink && item.function && !item.disabled) {
        <a
            class="hippo-vertical-navigation-item"
            [ngClass]="{
                'hippo-vertical-navigation-item-active-forced': item.active,
            }"
            [routerLink]="[item.link]"
            [fragment]="item.fragment ?? null"
            [preserveFragment]="item.preserveFragment ?? false"
            [queryParams]="item.queryParams ?? null"
            [queryParamsHandling]="item.queryParamsHandling ?? null"
            [routerLinkActive]="'hippo-vertical-navigation-item-active'"
            [routerLinkActiveOptions]="isActiveMatchOptions"
            [matTooltip]="item.tooltip || ''"
            (click)="item.function(item)">
            <ng-container *ngTemplateOutlet="itemTemplate"></ng-container>
        </a>
    }

    <!-- Item with an external link and function -->
    @if (item.link && item.externalLink && item.function && !item.disabled) {
        <a
            class="hippo-vertical-navigation-item"
            [href]="item.link"
            [target]="item.target || '_self'"
            [matTooltip]="item.tooltip || ''"
            (click)="item.function(item)">
            <ng-container *ngTemplateOutlet="itemTemplate"></ng-container>
        </a>
    }

    <!-- Item with a no link and no function -->
    @if (!item.link && !item.function && !item.disabled) {
        <div
            class="hippo-vertical-navigation-item"
            [ngClass]="{
                'hippo-vertical-navigation-item-active-forced': item.active,
            }"
            [matTooltip]="item.tooltip || ''">
            <ng-container *ngTemplateOutlet="itemTemplate"></ng-container>
        </div>
    }

    <!-- Item is disabled -->
    @if (item.disabled) {
        <div
            class="hippo-vertical-navigation-item hippo-vertical-navigation-item-disabled"
            [matTooltip]="item.tooltip || ''">
            <ng-container *ngTemplateOutlet="itemTemplate"></ng-container>
        </div>
    }
</div>

<!-- Item template -->
<ng-template #itemTemplate>
    <!-- Icon -->
    @if (item.icon) {
        <mat-icon
            class="hippo-vertical-navigation-item-icon"
            [ngClass]="$safeNavigationMigration(item.classes?.icon)"
            [svgIcon]="item.icon"></mat-icon>
    }

    <!-- Title & Subtitle -->
    <div class="hippo-vertical-navigation-item-title-wrapper">
        <div class="hippo-vertical-navigation-item-title">
            <span [ngClass]="$safeNavigationMigration(item.classes?.title)">
                {{ item.title }}
            </span>
        </div>
        @if (item.subtitle) {
            <div class="hippo-vertical-navigation-item-subtitle">
                <span
                    [ngClass]="
                        $safeNavigationMigration(item.classes?.subtitle)
                    ">
                    {{ item.subtitle }}
                </span>
            </div>
        }
    </div>

    <!-- Badge -->
    @if (item.badge) {
        <div class="hippo-vertical-navigation-item-badge">
            <div
                class="hippo-vertical-navigation-item-badge-content"
                [ngClass]="item.badge.classes">
                {{ item.badge.title }}
            </div>
        </div>
    }
</ng-template>
